// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2losh","fileBtn":"File_fileBtn__3WSj2","closeBtn":"File_closeBtn__9xblg","fileSelected":"File_fileSelected__37F5L","disabled":"File_disabled__2UAyp"};